export default __webpack_public_path__ + "public/media/qr-code-ios.f0abff62.webp";